import { render, staticRenderFns } from "./game-board.vue?vue&type=template&id=d5d65e08"
import script from "./game-board.vue?vue&type=script&lang=js"
export * from "./game-board.vue?vue&type=script&lang=js"
import style0 from "./game-board.vue?vue&type=style&index=0&id=d5d65e08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports